import { Injectable } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';

import { ConfirmationFormService } from './../confirmation-form.service';

import { ApiConstant } from './../../../utils/api-constant/api-constant.service';
import { ConfirmationConstantService } from './../shared/services/confirmation.const';
import { AlphaNumericalValidator } from '../../../validator/alphanumeric/alpha-numeric.validator';
import { RequiredSelectValidator } from '../../../validator/required-select/required-select.validator';
import { NumericalValidator } from '../../../validator/numerical/numerical.validator';
import { NoSpaceValidator } from '../../../validator/no-space/no-space.validator';
import { NoLeadingMinValidator } from '../../../validator/no-leading-min/no-leading-min.validator';

import { Subscription } from 'rxjs/Subscription';

import { RegionService } from '../../../services/region.service';
import { IExistingData } from './confirmation-work-place.model';
export class ConfirmationWorkPlaceService {
public dataStore: Observable<any>;
public validations: any;
private update: BehaviorSubject<any>;
private store;
private isSecondLoan: boolean;
public subscription: Subscription = new Subscription();
/**
 * @param {?} fb
 * @param {?} http
 * @param {?} api
 * @param {?} constant
 * @param {?} parentService
 * @param {?} regionService
 */
constructor(
private fb: FormBuilder,
private http: HttpClient,
private api: ApiConstant,
private constant: ConfirmationConstantService,
public parentService: ConfirmationFormService,
public regionService: RegionService,
  ) {
    // main store
    this.store = {
      buildingType: [],
      provinces: [],
      cities: [],
      districts: [],
      villages: [],
      initialData: null,
      workPlaceForm: null,
      errors: {
        compOrBuilding: '',
        buildingNumber: '',
        flatNumber: '',
        buildingType: '',
        street: '',
        rt: '',
        rw: '',
        province: '',
        city: '',
        district: '',
        village: '',
        postalCode: '',
        officePhoneNumber: '',
        jobRole: '',
      },
    };

    // main function for dispatcher
    this.update = <BehaviorSubject<any>>new BehaviorSubject({});
    this.dataStore = this.update.asObservable();
    this.update.next(this.store);

    this.validations = this.constant.validations;
  }
/**
 * @return {?}
 */
initData() {
    this.setStore({
      buildingType: this.constant.buildingType,
    });
  }
/**
 * @param {?} token
 * @return {?}
 */
public getProfileData(token: any): Observable<boolean> {
    const /** @type {?} */ headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': token,
      }),
    };

    return new Observable<boolean>(observer => {
      this.http
        .get(`${this.api.apiURL}/loan/confirm/history`, headers)
        .subscribe(
          (data: any) => {
            this.isSecondLoan = true;

            this.setStore({
              initialData: data,
            });

            observer.next(true);
            observer.complete();
          },
          (error: HttpErrorResponse) => {
            if (error.status === 404) {
              this.isSecondLoan = false;
              observer.next(true);
            }

            observer.complete();
          },
        );
    });
  }
/**
 * @param {?=} existingData
 * @return {?}
 */
public form(existingData: IExistingData = null): object {
    return {
      compOrBuilding: [
        existingData === null ? '' : existingData.compOrBuilding,
        [
          Validators.maxLength(50),
          NoSpaceValidator(),
          NoLeadingMinValidator(),
          Validators.required,
        ],
      ],
      buildingNumber: [
        existingData === null ? '' : existingData.buildingNumber,
        [
          Validators.maxLength(5),
          AlphaNumericalValidator(),
          Validators.required,
        ],
      ],
      flatNumber: [
        existingData === null ? '' : existingData.flatNumber,
        [
          Validators.maxLength(5),
          AlphaNumericalValidator(),
          Validators.required,
        ],
      ],
      buildingType: [
        existingData === null ? '0' : existingData.buildingType,
        [RequiredSelectValidator()],
      ],
      street: [
        existingData === null ? '' : existingData.street,
        [
          Validators.maxLength(100),
          NoSpaceValidator(),
          Validators.minLength(2),
          Validators.required,
        ],
      ],
      rt: [
        existingData === null ? '' : existingData.rt,
        [Validators.maxLength(3), NumericalValidator(), Validators.required],
      ],
      rw: [
        existingData === null ? '' : existingData.rw,
        [Validators.maxLength(3), NumericalValidator(), Validators.required],
      ],
      province: [
        existingData === null ? '0' : existingData.province,
        [RequiredSelectValidator()],
      ],
      city: [
        existingData === null ? '0' : existingData.city,
        [RequiredSelectValidator()],
      ],
      district: [
        existingData === null ? '0' : existingData.district,
        [RequiredSelectValidator()],
      ],
      village: [
        existingData === null ? '0' : existingData.village,
        [RequiredSelectValidator()],
      ],
      postalCode: [
        existingData === null ? '' : existingData.postalCode,
        [RequiredSelectValidator()],
      ],
      officePhoneNumber: [
        existingData === null ? '' : existingData.officePhoneNumber,
        [
          Validators.maxLength(13),
          Validators.minLength(9),
          NumericalValidator(),
          Validators.required,
        ],
      ],
      jobRole: [
        existingData === null ? '' : existingData.jobRole,
        [
          Validators.maxLength(100),
          NoSpaceValidator(),
          NoLeadingMinValidator(),
          Validators.required,
        ],
      ],
    };
  }
/**
 * @return {?}
 */
public setInitialRegion(): void {
    this.subscription.add(
      this.regionService
        .inquireRegionDataByUserSubmission(this.store.initialData)
        .subscribe(data => {
          this.setStore({
            cities: data.cities['result'],
            districts: data.districts['result'],
            villages: data.villages['result'],
          });
        }),
    );
  }
/**
 * @return {?}
 */
public buildForm(): void {
    const /** @type {?} */ isSecondLoanAutoFill =
      this.store.workPlaceForm === null && this.isSecondLoan;

    const /** @type {?} */ isModifiedData = this.store.workPlaceForm !== null;

    let /** @type {?} */ form;
    // if secondloan or topup
    if (isSecondLoanAutoFill) {
      this.setInitialRegion();

      form = this.form(this.store.initialData);
    }
    // if data touched
    else if (isModifiedData) {
      form = this.form(this.store.workPlaceForm.value);
    }
    // if firstloan or haven't fill acc form
    else {
      form = this.form();
    }

    this.setStore({
      workPlaceForm: this.fb.group(form),
    });

    this.subscription.add(
      this.store.workPlaceForm.valueChanges.subscribe(data => {
        this.onChangedValues(data);
      }),
    );
  }
/**
 * @param {?} data
 * @return {?}
 */
private onChangedValues(data: any) {
    const /** @type {?} */ form = this.store.workPlaceForm;
    const /** @type {?} */ errors = this.store.errors;

    for (const /** @type {?} */ field in errors) {
      if (errors.hasOwnProperty(field)) {
        const /** @type {?} */ control = form.get(field);
        errors[field] = '';

        this.setStore({ errors: errors });

        if (control && control.dirty && !control.valid) {
          for (const /** @type {?} */ key in control.errors) {
            if (errors.hasOwnProperty(field)) {
              errors[field] = `${this.validations[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        } else if (
          control &&
          control.invalid &&
          (control.value !== '' && control.value !== '0')
        ) {
          for (const /** @type {?} */ key in control.errors) {
            if (errors.hasOwnProperty(field)) {
              errors[field] = `${this.validations[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        }
      }
    }
  }
/**
 * @param {?} data
 * @param {?} type
 * @param {?=} objType
 * @param {?=} onChange
 * @return {?}
 */
public getRegions(data, type, objType?: string, onChange?: boolean) {
    this.setStore({ actionBusy: true });
    switch (type) {
      case 'province': {
        this.http
          .get(`${this.api.apiURL}/general/region?type=province`)
          .subscribe(
            (data: any) => {
              this.setStore({
                provinces: data.result,
                actionBusy: false,
              });
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );
        break;
      }
      case 'city': {
        if (onChange) {
          const /** @type {?} */ selected = this.store.provinces.find(
            c => c.province === data.province,
          );
          this.setStore({
            selectedProvince: selected.province_id ? selected.province_id : '',
            districts: [],
            villages: [],
            postal_codes: [],
          });
          this.store.workPlaceForm.patchValue({
            city: '0',
            district: '0',
            village: '0',
            postalCode: '0',
          });
        }
        this.http
          .get(
            `${this.api.apiURL}/general/region?province=${this.store.selectedProvince}&type=city`,
          )
          .subscribe(
            (data: any) => {
              if (!objType) {
                this.setStore({
                  cities: data.result,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  citiesContact: data.result,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );
        break;
      }
      case 'district': {
        if (onChange) {
          const /** @type {?} */ selected = this.store.cities.find(c => c.city === data.city);
          this.setStore({
            selectedCity: selected.city_id,
            villages: [],
            postal_codes: [],
          });
          this.store.workPlaceForm.patchValue({
            district: '0',
            village: '0',
            postalCode: '0',
          });
        }
        this.http
          .get(
            `${this.api.apiURL}/general/region?province=${this.store.selectedProvince}&city=${this.store.selectedCity}&type=district`,
          )
          .subscribe(
            (data: any) => {
              this.setStore({
                districts: data.result,
                actionBusy: false,
              });
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );
        break;
      }
      case 'village': {
        if (onChange) {
          const /** @type {?} */ selected = this.store.districts.find(
            c => c.district === data.district,
          );
          this.setStore({
            selectedDistrict: selected.district_id,
            postal_codes: [],
          });
          this.store.workPlaceForm.patchValue({
            village: '0',
            postalCode: '0',
          });
        }
        this.http
          .get(
            `${this.api.apiURL}/general/region?province=${this.store.selectedProvince}&city=${this.store.selectedCity}&district=${this.store.selectedDistrict}&type=village`,
          )
          .subscribe(
            (data: any) => {
              this.setStore({
                villages: data.result,
                actionBusy: false,
              });
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );
        break;
      }
      case 'postal_code': {
        if (onChange) {
          const /** @type {?} */ selected = this.store.villages.find(
            c => c.village === data.village,
          );
          this.setStore({
            actionBusy: false,
          });
          this.store.workPlaceForm.patchValue({
            postalCode: selected.postal_code,
          });
        }
        break;
      }
    }
  }
/**
 * @param {?} obj
 * @return {?}
 */
private setStore(obj: any) {
    const /** @type {?} */ data = ( /** @type {?} */((<any>Object))).assign(this.store, obj);
    this.update.next(data);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: HttpClient, },
{type: ApiConstant, },
{type: ConfirmationConstantService, },
{type: ConfirmationFormService, },
{type: RegionService, },
];
}

function ConfirmationWorkPlaceService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationWorkPlaceService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationWorkPlaceService.ctorParameters;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.dataStore;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.validations;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.update;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.store;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.isSecondLoan;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.subscription;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.fb;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.http;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.api;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.constant;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.parentService;
/** @type {?} */
ConfirmationWorkPlaceService.prototype.regionService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
